import script from "./MessageLog.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageLog.vue?vue&type=script&setup=true&lang=js"

import "./MessageLog.vue?vue&type=style&index=0&id=3f77c558&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f77c558"]])

export default __exports__